module.exports = __webpack_public_path__ + "img/home2.7cdba136.png";